import { render } from "./BookingHours.vue?vue&type=template&id=5ac2ee37&scoped=true"
import script from "./BookingHours.vue?vue&type=script&lang=js"
export * from "./BookingHours.vue?vue&type=script&lang=js"

import "./BookingHours.vue?vue&type=style&index=0&id=5ac2ee37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac2ee37"]])

export default __exports__